(function() {
  'use strict';

  class ScrollReveal {
    constructor() {
      this.observer = null;
      this.init();
    }

    init() {
      this.createObserver();
      this.observeElements();
      this.setupShopifyEvents();
    }

    createObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              this.observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -80px 0px'
        }
      );
    }

    observeElements() {
      const selectors = [
        '[data-section-reveal]',
        '[data-stagger-children]',
        '[data-hero-image]'
      ];

      document.querySelectorAll(selectors.join(',')).forEach(el => {
        if (!el.classList.contains('is-revealed')) {
          this.observer.observe(el);
        }
      });
    }

    setupShopifyEvents() {
      document.addEventListener('shopify:section:load', (event) => {
        const section = event.target;
        const selectors = '[data-section-reveal], [data-stagger-children], [data-hero-image]';

        section.querySelectorAll(selectors).forEach(el => {
          el.classList.remove('is-revealed');
        });

        setTimeout(() => this.observeElements(), 100);
      });
    }
  }

  function initStarsAnimation() {
    const starsContainers = document.querySelectorAll('[data-stars-animate]');

    if (!starsContainers.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-animated');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    starsContainers.forEach(container => observer.observe(container));
  }

  function initSidecartAnimation() {
    const drawer = document.querySelector('ui-cart-drawer, .drawer--cart, [data-cart-drawer]');
    if (!drawer) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'open' || mutation.attributeName === 'class') {
          const isOpen = drawer.hasAttribute('open') || drawer.classList.contains('is-open');
          if (isOpen) {
            const items = drawer.querySelectorAll('.cart-item, [data-cart-item]');
            items.forEach(item => {
              item.style.animation = 'none';
              item.offsetHeight;
              item.style.animation = '';
            });
          }
        }
      });
    });

    observer.observe(drawer, { attributes: true });
  }

  function init() {
    window.wScrollReveal = new ScrollReveal();
    initStarsAnimation();
    initSidecartAnimation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
